<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="indigo" dark icon v-bind="attrs" v-on="on" title="Renomear Pasta">
          <v-icon>mdi-folder-edit-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-text>
          <v-text-field label="Nome" v-model="newFolderName" hide-details></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelar"> Cancelar </v-btn>
          <v-btn color="primary" text @click="rename"> Renomear </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    newFolderName: "",
  }),
  props: {
    itemStorage: {
      require: false,
    },
    projetoId: {
      require: false,
    },
    pathPai: {
      require: false,
    },
  },
  methods: {
    cancelar() {
      this.menu = false;
      this.newFolderName = "";
    },
    async rename() {
      this.$emit("loading", true);

      const payload = {
        projetoId: this.projetoId,
        pathPai: this.pathPai,
        itemStorageId: this.itemStorage.id,
        novoNome: this.newFolderName,
      };

      await this.$store.dispatch("storage/rename", payload);

      this.$emit("folder-rename", this.newFolderName);

      this.menu = false;
      this.newFolderName = "";
      this.$emit("loading", false);
    },
  },
};
</script>
